export const mobile = {
  min: '768px',
  max: '767px',
};

export const smallDesktop = {
  min: '1024px',
  max: '1023px',
};
